import React, { useState, useEffect } from 'react';
import './index.css';
import Nav from './components/Nav';
import Footer from './components/Footer';
import RsvpOverlay from './components/RsvpOverlay';
import Home from './pages/Home';
import Info from './pages/Info';
import Catering from './pages/Catering';
import Gifting from './pages/Gifting';

export default function App() {
  const [rsvpOpen, setRsvpOpen] = React.useState(false);
  const [activeSection, setActiveSection] = React.useState('home');

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('code')) {
      setRsvpOpen(true);
    }
  }, []);

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80; // Account for sticky nav
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  React.useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'info', 'catering', 'gifting'];
      const headerOffset = 100;
      
      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= headerOffset && rect.bottom > headerOffset) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Nav 
        onRsvp={() => setRsvpOpen(true)} 
        activeSection={activeSection}
        onNavigate={scrollToSection}
      />
      <main>
        <section id="home" className="page-section">
          <Home onRsvp={() => setRsvpOpen(true)} />
        </section>
        
        <section id="info" className="page-section">
          <Info onRsvp={() => setRsvpOpen(true)} onNavigate={scrollToSection} />
        </section>
        
        <section id="catering" className="page-section">
          <Catering onRsvp={() => setRsvpOpen(true)} />
        </section>
        
        <section id="gifting" className="page-section">
          <Gifting />
        </section>
      </main>
      <Footer />
      <RsvpOverlay open={rsvpOpen} onClose={() => setRsvpOpen(false)} />
    </>
  );
}